module.exports = "#header {\n   padding-top: 20px;\n}\n\n#footer {\n   position:fixed;\n   left:0px;\n   bottom:0px;\n   width:100%;\n   padding: 10px 30px 10px 30px;\n   background-color: white;\n   border-top: solid 1px lightgray;\n}\n\n.griphcustom{\n   position: absolute;\n   top: 10px;\n   right: 10px;\n   font-size: 40px;\n}\n\nrl-tag-input-item {\n    text-transform: uppercase;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main